export const SALES_TAX_NEXUS_STUDY = "SALES_TAX_NEXUS_STUDY";
